class h {
  application;
  district_id;
  timestamp;
  locations = {};
  duration = 0;
  constructor(t, e) {
    this.timestamp = (/* @__PURE__ */ new Date()).toISOString(), this.district_id = t, this.application = e;
  }
  addLocation(t) {
    const e = `${t.product}:${t.location}`;
    this.duration += t.duration;
    const i = this.locations[e]?.duration ?? 0;
    this.locations[e] = {
      duration: i + t.duration
    };
  }
}
class d {
  getAuthCallback;
  syncOptions;
  constructor(t) {
    this.syncOptions = t, this.getAuthCallback = t.getAuthCallback, this.log("TeacherTotterSync initialized with options: ", t);
  }
  async sync(t, e, i) {
    return Object.keys(t.locations).length === 0 ? !1 : (this.log("Syncing session with locations: ", t.locations), await new o(t, this.syncOptions.syncUrl, this.getAuthCallback, this.syncOptions.debugMode, e, i).sync());
  }
  async sendEvent(t) {
    return this.log("Sending event: ", t), await new o(
      new h(),
      this.syncOptions.syncUrl,
      this.getAuthCallback,
      this.syncOptions.debugMode
    ).sendEvent(t);
  }
  log(...t) {
    this.syncOptions?.debugMode && console.debug(...t);
  }
}
class o {
  headers = {
    "content-type": "application/json"
  };
  getAuthCallback;
  debugMode;
  onSuccess;
  onFailure;
  retryCount = 0;
  session;
  syncUrl;
  constructor(t, e, i, n, c, u) {
    this.session = t, this.syncUrl = e, this.debugMode = n, this.onSuccess = c, this.onFailure = u, i && (this.getAuthCallback = i);
  }
  async applyAuth() {
    if (this.getAuthCallback) {
      const t = await this.getAuthCallback();
      t && (this.headers.authorization = t);
    }
  }
  async sync() {
    if (Object.keys(this.session.locations).length === 0) return;
    await this.applyAuth(), r("teacher-tot-sync-started");
    const t = `${this.syncUrl}/session_event`;
    this.log("Syncing session with URL: ", t);
    try {
      const e = await fetch(t, {
        method: "POST",
        body: JSON.stringify(this.session),
        headers: this.headers,
        keepalive: !0
      });
      return e.ok ? (this.log("Sync successful"), this.onSuccess?.(), r("teacher-tot-sync-complete"), !0) : (this.log("Sync failed with status: ", e.status), this.retry(), !1);
    } catch (e) {
      console.error(e), this.retry();
    }
  }
  async sendEvent(t) {
    await this.applyAuth();
    const e = `${this.syncUrl}/teacher_event`;
    this.log("Sending event to URL: ", e);
    try {
      const i = await fetch(e, {
        method: "POST",
        body: JSON.stringify(t),
        headers: this.headers,
        keepalive: !0
      });
      return i.ok ? (this.log("Event sent successfully"), r("teacher-tot-event-sent"), !0) : (this.log("Event sending failed with status: ", i.status), this.retrySendEvent(t), !1);
    } catch (i) {
      return console.error(i), this.retrySendEvent(t), !1;
    }
  }
  retry() {
    this.retryCount < 3 ? (this.log("Retrying sync..."), this.retryCount += 1, setTimeout(() => {
      this.sync();
    }, 5e3)) : this.onFailure?.();
  }
  retrySendEvent(t) {
    this.retryCount < 3 && (this.log("Retrying event send..."), this.retryCount += 1, setTimeout(() => {
      this.sendEvent(t);
    }, 5e3));
  }
  log(...t) {
    this.debugMode && console.debug(...t);
  }
}
class l {
  timer;
  idleTimeout;
  incrementCallback;
  lastUserActivity;
  tickFrequency;
  constructor({ idleTimeout: t = 6e4, incrementCallback: e, tickFrequency: i = 1e3 }) {
    this.incrementCallback = e, this.tickFrequency = i, this.idleTimeout = t, this.lastUserActivity = (/* @__PURE__ */ new Date()).getTime(), this.tick();
  }
  tick() {
    if (this.shouldPause) {
      r("teacher-totter-pause"), this.timer = void 0;
      return;
    }
    this.timer = setTimeout(() => {
      r("teacher-totter-tick"), this.increment(), this.tick();
    }, this.tickFrequency);
  }
  increment() {
    r("teacher-totter-increment"), this.incrementCallback();
  }
  get shouldPause() {
    return (/* @__PURE__ */ new Date()).getTime() - this.lastUserActivity > this.idleTimeout;
  }
  userActive() {
    this.lastUserActivity = (/* @__PURE__ */ new Date()).getTime(), this.resume();
  }
  removeTimer() {
    clearTimeout(this.timer), this.timer = void 0;
  }
  resume() {
    this.timer || (r("teacher-totter-resume"), this.tick());
  }
}
class y {
  districtId;
  browser;
  application;
  constructor(t, e) {
    this.browser = navigator.userAgent, this.districtId = t, this.application = e;
  }
  buildEvent(t) {
    return {
      districtId: this.districtId,
      application: this.application,
      browser: this.browser,
      eventName: t.eventName,
      product: t.product,
      additionalData: t.additionalData ?? {},
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
}
const a = "teacher-totter:pending-session";
class g {
  key;
  district_id;
  application;
  state;
  constructor(t, e, i) {
    this.key = t, this.district_id = e, this.application = i, this.state = this.loadOrInit(), this.recoverSyncing(), this.finalizeCurrentEvent();
  }
  get currentEvent() {
    return this.state.currentEvent;
  }
  get pending() {
    return this.state.pending;
  }
  get hasPendingData() {
    return Object.keys(this.state.pending).length > 0;
  }
  trackLocation(t, e) {
    this.state.currentEvent = { location: t, product: e, duration: 0 }, this.persist();
  }
  incrementTimeAtLocation() {
    this.state.currentEvent && (this.state.currentEvent.duration += 1, this.persist());
  }
  finalizeCurrentEvent() {
    if (!this.state.currentEvent) return;
    const { location: t, product: e, duration: i } = this.state.currentEvent, n = `${e}:${t}`, c = this.state.pending[n]?.duration ?? 0;
    this.state.pending[n] = { duration: c + i }, this.state.currentEvent = void 0, this.persist();
  }
  startSync() {
    if (Object.keys(this.state.pending).length === 0) return null;
    const t = new h(this.district_id, this.application);
    return t.locations = { ...this.state.pending }, t.duration = Object.values(this.state.pending).reduce((e, { duration: i }) => e + i, 0), this.state.syncing = { ...this.state.pending }, this.state.pending = {}, this.persist(), t;
  }
  confirmSync() {
    this.state.syncing = {}, this.persist();
  }
  failSync() {
    for (const [t, { duration: e }] of Object.entries(this.state.syncing)) {
      const i = this.state.pending[t]?.duration ?? 0;
      this.state.pending[t] = { duration: i + e };
    }
    this.state.syncing = {}, this.persist();
  }
  recoverSyncing() {
    Object.keys(this.state.syncing).length !== 0 && this.failSync();
  }
  loadOrInit() {
    try {
      const t = localStorage.getItem(this.key);
      if (t) return JSON.parse(t);
    } catch {
    }
    return this.emptyState();
  }
  emptyState() {
    return {
      pending: {},
      syncing: {}
    };
  }
  persist() {
    try {
      this.isEmpty() ? localStorage.removeItem(this.key) : localStorage.setItem(this.key, JSON.stringify(this.state));
    } catch {
    }
  }
  isEmpty() {
    return !this.state.currentEvent && Object.keys(this.state.pending).length === 0 && Object.keys(this.state.syncing).length === 0;
  }
}
const f = [
  "keypress",
  "keydown",
  "click",
  "contextmenu",
  "dblclick",
  "mousemove",
  "scroll",
  "touchmove",
  "touchstart"
];
function p(s, t) {
  return s || (t ? `${a}:${t}` : a);
}
class m {
  application;
  district_id;
  eventBuilder;
  syncer;
  ticker;
  buffer;
  options;
  constructor({ districtId: t, application: e, options: i }) {
    this.district_id = t, this.application = e;
    const n = p(i.storageKey, e?.name);
    this.buffer = new g(n, t, e), this.syncer = new d({
      ...i.syncOptions,
      debugMode: i.debugMode
    }), this.eventBuilder = new y(t, this.application), this.options = i, this.log("TeacherTotter initialized with options: ", i), this.buffer.hasPendingData && (this.log("Found pending data in storage, syncing immediately"), setTimeout(() => this.sync(), 0)), window.addEventListener("blur", () => {
      this.ticker?.removeTimer();
    }), f.forEach((c) => {
      window.addEventListener(c, () => this.refreshTicker());
    }), document.addEventListener("visibilitychange", async () => {
      document.visibilityState === "hidden" && await this.sync();
    }), setInterval(() => this.sync(), i.syncFrequency ?? 6e4), i.debugMode && (window.tot = this);
  }
  refreshTicker() {
    this.ticker && this.ticker.userActive();
  }
  async trackSession(t, e) {
    this.untrackSession(), this.buffer.trackLocation(t, e), this.ticker = new l({
      idleTimeout: this.options.idleTimeout,
      incrementCallback: () => {
        this.buffer.incrementTimeAtLocation();
      }
    }), this.log(`Tracking session: ${t} for product: ${e}`), r("teacher-totter-track-session", {
      detail: {
        name: t
      }
    });
  }
  /*
  /** Send an event to the backend
   *
   * @param eventName - The name of the event
   * @param product - The product associated with the event
  * @param additionalData - Any additional data to send with the event.
   */
  async sendEvent(t, e, i) {
    const n = this.eventBuilder.buildEvent({
      eventName: t,
      product: e,
      additionalData: i
    });
    return this.log("Sending event: ", n), this.syncer.sendEvent(n);
  }
  untrackSession() {
    this.ticker && (this.log(`Untracking session: for product: ${this.buffer.currentEvent?.product} `, this.buffer.currentEvent), this.buffer.finalizeCurrentEvent(), this.ticker.removeTimer(), this.ticker = void 0);
  }
  async sync() {
    this.log("Syncing data...");
    const t = this.buffer.startSync();
    t && await this.syncer.sync(
      t,
      () => this.buffer.confirmSync(),
      () => this.buffer.failSync()
    );
  }
  log(...t) {
    this.options?.debugMode && console.debug(...t);
  }
}
function r(s, t) {
  const e = new CustomEvent(s, t);
  document.dispatchEvent(e);
}
export {
  f as ACTIVITY_EVENTS,
  m as TeacherTotter,
  r as dispatchTeacherTotterEvent
};



// WEBPACK FOOTER //
// ./~/@3plearning/teacher-totter/dist/teacher-totter.js